import { Outlet, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import NavbarV2 from '@/components/navbar-v2';
import modelChoiceStore from '@/components/model-choice/store';
import ClientHeader from '@/components/client/header';
import { useEffect, useMemo } from 'react';
import localRobot from '@/common/localRobot.js';
import apiRobot from '@/common/apiRobot';
import ToolsPage from '../tools';
import globalStore from '@/store/global';
import navbarStore from '@/store/navbar';
import UpgradeModal from '@/components/modal/upgrade';
import client from '@/store/client';
import { HelperCore } from '@/common/dependencies';
import urlStore from '@/store/chat/urlStore';
import inputTypeStore from '@/components/input-file/input-type';
import FpsMonitor from '@/components/fps-monitor';

const isCurIframe = (location, item)=>{
  return location.pathname == `/tools/${item.type}`;
}

const MainPage = observer(({ className = '', style = {} }) => {
  const location = useLocation();
  const iframeList = globalStore.cloudConfig?.assistantLeftSideTools?.filter(item => item.open_type == 3) || [];

  const initData = async () => {
    // 可选模型
    await modelChoiceStore.getList();
    // 初始化本地模型
    localRobot.start();
    // 初始化API模型
    apiRobot.start();
  }

  useEffect(() => {
    initData()
  }, []);

  const showNavbar = useMemo(() => {
    return navbarStore.showNavbarRoutes.some((route) => {
      if(route === '/'){
        return location.pathname === route;
      }else {
        return location.pathname.startsWith(route);
      }
    });
  }, [location])

  const showAigentNavbar = () => {
    return location.pathname.startsWith("/agentchat") ||
           location.pathname.startsWith("/tools/aiagent/chat")
  }

  const showAimodelNavBar = () => {
    return location.pathname.startsWith("/chathome") || location.pathname.startsWith("/chat")
  }

  // 提升升级
  useEffect(() => {
    globalStore.whenCloudReady(() => {
      // 在旧版智能体页，提升升级，使用新版 Mcp 智能体
      if(
        location.pathname == "/tools/agent"
        && client.isLLQ
        && !client.supportMcpAgent
        && (
          (
            globalStore.cloudConfig.webConfig?.support_mcp_agent == 1
            && !HelperCore.isMac()
          )
          || (
            globalStore.cloudConfig.webConfig?.support_mcp_agent == 2
            && HelperCore.isMac()
          )
          || globalStore.cloudConfig.webConfig?.support_mcp_agent == 3
        )
        // 是否要弹窗提示限制次数
        && globalStore.getActionCount("upgradeMcp") < 3
      ){
        globalStore.addActionCount("upgradeMcp");
        UpgradeModal.show({
          title : "请升级到最新版本，体验最新智能体功能：",
          desc : "1. 接入超多MCP工具\n2. 智能体自主规划完成任务",
        })
      }
      // 在浏览器中，提升下载客户端，使用新版 Mcp 智能体
      if(
        location.pathname == "/tools/agent"
        && (
          !client.isLLQ
          && !client.isClient
        )
        && (
          (
            globalStore.cloudConfig.webConfig?.support_mcp_agent == 1
            && !HelperCore.isMac()
          )
          || (
            globalStore.cloudConfig.webConfig?.support_mcp_agent == 2
            && HelperCore.isMac()
          )
          || globalStore.cloudConfig.webConfig?.support_mcp_agent == 3
        )
        // 是否要弹窗提示限制次数
        && globalStore.getActionCount("upgradeMcp") < 3
      ){
        globalStore.addActionCount("upgradeMcp");
        UpgradeModal.show({
          title : "请去 纳米AI PC端，体验最新智能体功能：",
          desc : "1. 接入超多MCP工具\n2. 智能体自主规划完成任务",
          btnText : "立即下载",
        })
      }
    })

    return () => {
      UpgradeModal?.close?.();
    }
  }, [location]);

  useEffect(() => {
    // 记录历史
    urlStore.handleLocationChange(location);
    // 清空上传文件
    inputTypeStore.reset();
  }, [location]);

  const { debug } = HelperCore.getParams();
  const showFps = useMemo(() => {
    if (!['master', 'online'].includes(import.meta.env.MODE)) {
      return true;
    }
    if (debug && debug.includes('fps')) {
      return true;
    }
    return false;
  }, [debug]);

  return (
    <div style={style} className={`w-full h-full flex flex-col ${className}`}>
      <ClientHeader />
      <div className="flex h-0 flex-grow">
        { showFps && <FpsMonitor />}
        {
          showNavbar ? <NavbarV2 scene={showAigentNavbar() ? "aigent" : (showAimodelNavBar() ? "aimodel" : "")}/> : null
        }
        {/* 切换路由时不销毁iframe */}
        {iframeList.map((item, index) => {
          const isCur = isCurIframe(location, item);
          if(isCur){
            item.loaded = true;
          }
          return (
            <ToolsPage
              key={index}
              type={item.type}
              loaded={item.loaded}
              className={[isCur ? '' : 'hidden']}
            />
          );
        })}
        {iframeList.find(item => isCurIframe(location, item)) ? null : (
          <Outlet />
        )}
      </div>
    </div>
  );
});
export default MainPage;
